import "./EnvelopeNote";
import madeForYou from '../assets/images/madeForYou.png'
import React from "react";

function ForYouFooter(props) {
  return (
    <div>
        <img src={madeForYou} alt="made for you with e-florals" className="madeForYouText" />
        <a className="href" href='/' rel="noreferrer" target="_blank">
            <p className="navButton forYouFooterButton">visit the flowershop</p>
        </a>
    </div>
  );
}

export default ForYouFooter;
